module.exports = __webpack_public_path__ + "static/media/jezero.png";